import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import NoticeTextInput from "components/complex/nationalNotice/components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "components/complex/nationalNotice/components/inputs/NoticeGlossaryInput";
import NoticeNumericInput from "components/complex/nationalNotice/components/inputs/NoticeNumericInput";
import FormTranslationContext from "context/FormTranslationContext";

function AnnualReportBelowEuEditForm(
    {
        entry,
        newEntry,
        buttonWorks,
        reportStep,
        formikProps
    }) {
    const {getDict} = useContext(FormTranslationContext)
    return (<>
        <NoticeGlossaryInput
            label={`mmia.${reportStep}.type`}
            id="type"
            formikProps={formikProps}
            items={getDict("MP.MMiA.BelowEU.procedure")}
            disabled={buttonWorks.anyWorks}
        />
        <NoticeTextInput
            label={`mmia.${reportStep}.number`}
            id="number"
            formikProps={formikProps}
            disabled={buttonWorks.anyWorks || entry.demandId != null}
        />
        <NoticeGlossaryInput
            label={`mmia.${reportStep}.orderType`}
            id="orderType"
            formikProps={formikProps}
            items={getDict("ENUM.002")}
            disabled={buttonWorks.anyWorks}
        />
        <NoticeNumericInput
            label={`mmia.${reportStep}.amount`}
            id="amount"
            formikProps={formikProps}
            disabled={buttonWorks.anyWorks}
        />
    </>)
}

AnnualReportBelowEuEditForm.propTypes = {
    entry: PropTypes.object.isRequired,
    newEntry: PropTypes.bool,
    buttonWorks: PropTypes.shape({anyWorks: PropTypes.bool.isRequired}).isRequired,
    reportStep: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired
}

export default AnnualReportBelowEuEditForm;